import styled from 'styled-components';

export const OrdersFilterWrapper = styled.div`
  display: flex;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.white};
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;

  & > * + * {
    margin-inline-start: 10px;
  }
`;

export const OrdersFilterSearchBarWrapper = styled.div`
  flex-basis: 50%;
  position: relative;
`;

export const OrdersFilterSearchBar = styled.input`
  width: 100%;
  height: 36px;
  padding: 8px 36px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grey002};
  background-color: ${({ theme }) => theme.colors.grey100};
  border: none;
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: none;
    outline: none;
  }
`;

export const OrdersFilterSearchBarIcon = styled.i`
  position: absolute;
  top: 9px;
  left: 13px;
  color: ${({ theme }) => theme.colors.grey002};
  font-style: normal;

  &:before {
    content: '\\e905';
    font-family: 'Icomoon';
  }
`;

export const OrdersFilterClearIcon = styled.i`
  position: absolute;
  top: 9px;
  right: 9px;
  color: ${({ theme }) => theme.colors.grey002};
  font-style: normal;
  cursor: pointer;

  &:before {
    content: '\\e918';
    font-family: 'Icomoon';
  }

  &:hover {
    color: ${({ theme }) => theme.colors.redMain};
    transition: all 150ms ease-in-out;
  }
`;

export const MoreFiltersButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin-left: 10px;
  padding: 10px 12px;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid ${({ theme }) => theme.colors.grey003};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  font-family: 'Lato';
  font-weight: 400;
  font-size: 13px;
  white-space: nowrap;

  ${({ selected, theme }) =>
    selected &&
    `
    border-color: ${theme.colors.blueMain};
    background-color: ${theme.colors.blueLight};
    color: ${theme.colors.blueMain};
  `}
`;

export const MoreFitlersClearIcon = styled.div`
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  margin-left: 10px;
  color: ${({ theme }) => theme.colors.blueMain};

  &:before {
    content: '\\e91f';
    font-family: 'Icomoon';
  }
  &:hover {
    color: ${({ theme }) => theme.colors.redMain || ''};
    transition: all 150ms ease-in-out;
  }
`;
